import * as React from "react";
import { useRouter } from "next/router";
import { createOrchestrator } from "@nju/data-access-portal-orchestrator";
import { useMemberProducts } from "@nju/data-access-portal-product";
import { portalRoutes } from "@nju/routes";
import { BlockText, Button, Modal, useOverlay } from "@nju/ui";

type IStates = "IDLE" | "LOADING" | "ERROR" | "DONE";

interface IMobileReactivationButtonProps {
  offerId?: string;
  userId: string | undefined;
}

export function MobileReactivationButton({
  offerId,
  userId,
}: IMobileReactivationButtonProps) {
  const [currentState, setCurrentState] = React.useState<IStates>("IDLE");
  const router = useRouter();
  const { mobileProducts } = useMemberProducts();
  const modal = useOverlay();

  const onButtonClick = async () => {
    setCurrentState("LOADING");

    createOrchestrator("NJU_MOBILE_REACTIVATION", {
      ...(mobileProducts?.mobileAccess?.id && {
        product: { id: mobileProducts.mobileAccess.id },
        offerIds: [offerId],
      }),
    }).then((result) => {
      if (result.isOk) {
        router.push(
          portalRoutes.mojeKonto.mojeUslugi.reaktywacja.index.get({
            mode: "mobile",
            ...(userId && {
              userId,
            }),
          }),
        );

        return setCurrentState("DONE");
      }

      if (
        result.isError &&
        result.err.code === "ANOTHER_REACTIVATION_IN_PROGRESS"
      ) {
        modal.open();
        return setCurrentState("ERROR");
      }

      router.push(portalRoutes.ups.get());
      return setCurrentState("ERROR");
    });
  };

  return (
    <>
      {modal.isOpened && (
        <Modal onClose={modal.close} title="Jeszcze chwila">
          <BlockText className="mb-6" size="l">
            Spróbuj aktywować ten numer za 2-3 minuty, ponieważ w tym momencie
            trwa inne zlecenie na Twoim koncie.
          </BlockText>
          <div className="max-w-[142px]">
            <Button
              display="inline"
              onPress={modal.close}
              size={{ "@onlyMobile": "s" }}
              variant="primary"
            >
              ok
            </Button>
          </div>
        </Modal>
      )}
      {currentState !== "DONE" && (
        <Button
          isLoading={currentState === "LOADING"}
          onPress={() => {
            return onButtonClick();
          }}
        >
          zapłać i włącz usługę
        </Button>
      )}
    </>
  );
}
